var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { pick } from 'lodash';
import merge from 'lodash.merge';
import { useCallback, useEffect, useState } from 'react';
import { prepareAndFormat } from '../../../utils/strings';
import { DEFAULT_OPTIONS } from './Chart.defaults';
export default function useOptionsParser(_a) {
    var _b = _a.scaleOptions, scaleOptions = _b === void 0 ? {} : _b, customLegend = _a.customLegend, config = __rest(_a, ["scaleOptions", "customLegend"]);
    var _c = useState({}), parsedOptions = _c[0], setParsedOptions = _c[1];
    var parseFormatOptions = useCallback(function () {
        var _a;
        // Scale options
        var axisFormatOpts = undefined;
        Object.keys(scaleOptions).forEach(function (axis) {
            var scaleAxis = scaleOptions[axis];
            var formatOpts = scaleAxis.formatOpts;
            if (formatOpts) {
                axisFormatOpts = { opts: formatOpts, axis: axis };
                scaleAxis.ticks = {
                    callback: function (value) {
                        return prepareAndFormat(__assign({ mappedValues: { picked: value } }, formatOpts));
                    },
                };
            }
        });
        var tooltipOptions = {};
        if (axisFormatOpts) {
            tooltipOptions = {
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                return " ".concat(context.dataset.label, " ").concat(prepareAndFormat(__assign({ mappedValues: { picked: context.parsed[axisFormatOpts.axis] } }, axisFormatOpts.opts)));
                            },
                        },
                    },
                },
            };
        }
        // datalabels
        var datalabelsOptions = {};
        if ((_a = config.datalabels) === null || _a === void 0 ? void 0 : _a.formatOpts) {
            var _b = config.datalabels, formatOpts_1 = _b.formatOpts, stacked_1 = _b.stacked;
            datalabelsOptions = {
                plugins: {
                    datalabels: {
                        formatter: function (value, context) {
                            var parsedValue = value;
                            // This stacked props is used to stack all datalabels and show a sum value.
                            if (stacked_1) {
                                if (context.datasetIndex !== context.chart.data.datasets.length - 1)
                                    return null;
                                parsedValue = context.chart.data.datasets.reduce(function (acc, ds, index) {
                                    return (acc += context.chart.isDatasetVisible(index)
                                        ? ds.data[context.dataIndex] || 0
                                        : 0);
                                }, 0);
                            }
                            return !parsedValue
                                ? null
                                : prepareAndFormat(__assign({ mappedValues: { picked: parsedValue } }, formatOpts_1));
                        },
                    },
                },
            };
            // For horizontal charts, we need to setup a fix for cutting off datalabels
            // solution applied: move the label inside the chart
            if (config.indexAxis === 'y') {
                var baseConfig = datalabelsOptions.plugins.datalabels;
                datalabelsOptions.plugins.datalabels = __assign(__assign({}, baseConfig), { labels: {
                        value: {
                            align: 'left',
                            borderRadius: 5,
                            color: '#666',
                            backgroundColor: 'white',
                            padding: 5,
                            font: {
                                weight: 'bold',
                                size: 12,
                            },
                        },
                    } });
            }
        }
        return merge({}, { scales: scaleOptions }, tooltipOptions, datalabelsOptions);
    }, []);
    useEffect(function () {
        var pluginOptions = pick(config, ['title', 'legend', 'tooltip', 'datalabels']);
        var shouldHideGeneratedLegend = customLegend
            ? { plugins: { legend: { display: !customLegend } } }
            : {};
        var formatOptions = parseFormatOptions();
        var mergedOptions = merge({}, DEFAULT_OPTIONS, config, { plugins: pluginOptions }, shouldHideGeneratedLegend, formatOptions);
        setParsedOptions(mergedOptions);
    }, [customLegend]);
    return parsedOptions;
}
